var _polygon, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.6,470.67c-35.18,5.42-71.64-12.27-93.46-40.4s-30.06-65.19-27.76-100.71c1.82-28.22,10.78-57.35,31.6-76.49,33.29-30.6,84.39-26.87,128.12-38.37a178.81,178.81,0,0,0,81.58-47.29c17.2-17.49,30.79-38.55,49.75-54.12,45.16-37.11,120.34-49.84,172.85-24.16,33.23,16.25,45.49,31.86,59.26,52.64,19.29,29.1,21.12,65.51,15.54,100C640.43,320,602.34,445.48,515.14,470.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.12,
    cy: 148.1,
    r: 44.33,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.63,433.6l6.42,25.51,10.9,18.7a2.7,2.7,0,0,1-1.13,3.78h0a2.7,2.7,0,0,1-2.46,0c-4.9-2.64-22.86-12.45-23.22-14.34-.43-2.19-8.57-26.45-8.57-26.45Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.82,481.59,655.66,465.5l.3,1.07a4.06,4.06,0,0,0,1.63,2.28c2.13,1.45,8.11,5.31,21.69,12.72a2.69,2.69,0,0,0,2.54,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.61,455.88a1.63,1.63,0,0,1,1,1.94,1.56,1.56,0,0,1-1.9,1,1.72,1.72,0,0,1-1.05-2.05,1.63,1.63,0,0,1,2.1-.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673,472.11a8.51,8.51,0,0,1,1.68-2.59,8,8,0,0,1,2.77-1.36c0-.07-.37-.18-1-.1a4.31,4.31,0,0,0-3.44,3.06C672.83,471.72,672.9,472.11,673,472.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.71,475c.15.07.74-1,1.94-1.71a21.4,21.4,0,0,1,2.39-1,3,3,0,0,0-2.69.52C676,473.66,675.56,475,675.71,475Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.4,468.69a13.88,13.88,0,0,1,6.34-4.76,7.36,7.36,0,0,0-6.34,4.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.8,461.1c.11.13,1.35-.84,3.15-1.41s3.37-.53,3.38-.7-1.62-.48-3.56.15A5.23,5.23,0,0,0,665.8,461.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.72,453.66a13,13,0,0,1,3.25-1.55,13.37,13.37,0,0,1,3.59-.09c0-.06-.34-.3-1-.48a5.82,5.82,0,0,0-5.13,1.23C663.89,453.23,663.67,453.61,663.72,453.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.53,450.7a2.46,2.46,0,0,0-.23-1,7.15,7.15,0,0,0-1.46-2.3,3.07,3.07,0,0,0-1.65-1.06,1.1,1.1,0,0,0-1.12.56,1.83,1.83,0,0,0-.08,1.26,3.8,3.8,0,0,0,4.16,2.5,4.39,4.39,0,0,0,3.56-3.38,1.51,1.51,0,0,0-.27-1.25,1,1,0,0,0-1.22-.24,3.77,3.77,0,0,0-1.43,1.32,7.8,7.8,0,0,0-1.18,2.45,2.47,2.47,0,0,0-.15,1,12,12,0,0,1,1.66-3.19,3.54,3.54,0,0,1,1.27-1.13.58.58,0,0,1,.67.13,1.06,1.06,0,0,1,.13.83,4,4,0,0,1-3.13,2.9A3.3,3.3,0,0,1,662.5,448a1.28,1.28,0,0,1,0-.87.59.59,0,0,1,.61-.32,2.72,2.72,0,0,1,1.42.87A10.31,10.31,0,0,1,666.53,450.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.71,437.63l1.42,21.42s-21.32,7.08-21.45,11.07l41.67.3-.84-33.48Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594,456.86a1.71,1.71,0,0,1,1.23,1.91,1.64,1.64,0,0,1-1.88,1.24,1.8,1.8,0,0,1-1.29-2,1.69,1.69,0,0,1,2.09-1.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.35,470.42l-.08-3.38L561,468.16a2.85,2.85,0,0,0-1.55,2.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M580.45,458.86c0,.21,1,.27,2,.89s1.58,1.46,1.77,1.38-.16-1.25-1.4-2S580.4,458.68,580.45,458.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.14,460.8c0,.2.85.52,1.56,1.36s.95,1.74,1.15,1.73.3-1.17-.61-2.2S576.14,460.61,576.14,460.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.82,466.11c.18,0,.43-1-.12-2.09s-1.52-1.51-1.6-1.34.52.75,1,1.66S573.61,466.09,573.82,466.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.67,453.94c.09.19,1-.12,2.17-.08s2.06.38,2.16.2-.79-.87-2.14-.91S580.56,453.79,580.67,453.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "580 441.87 580.25 445.69 600.71 444.88 600.63 441.44 580 441.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M580.46,449.62a4,4,0,0,0,2.09-.08,9.65,9.65,0,0,0,2.16-.73,8.93,8.93,0,0,0,1.18-.68,2.26,2.26,0,0,0,.61-.51.88.88,0,0,0,.06-1.08,1.12,1.12,0,0,0-.9-.44,2.82,2.82,0,0,0-.78.13,7.74,7.74,0,0,0-1.28.49,7.13,7.13,0,0,0-1.89,1.32c-.94.92-1.24,1.69-1.17,1.73s.54-.59,1.5-1.36a8.43,8.43,0,0,1,1.83-1.1,8.32,8.32,0,0,1,1.19-.41c.43-.12.81-.14.93.05s0,.11,0,.24a2.28,2.28,0,0,1-.45.37,11.39,11.39,0,0,1-3.08,1.5A15,15,0,0,0,580.46,449.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.74,449.9a3.38,3.38,0,0,0,.49-2,6.85,6.85,0,0,0-.36-2.28,7.26,7.26,0,0,0-.57-1.25,1.72,1.72,0,0,0-1.36-1,1,1,0,0,0-.85.61,2.7,2.7,0,0,0-.19.77,4.34,4.34,0,0,0,0,1.4,4.72,4.72,0,0,0,.95,2.13c.85,1.06,1.71,1.27,1.72,1.2S580,449,579.3,448a4.79,4.79,0,0,1-.72-1.94,4.38,4.38,0,0,1,0-1.2c0-.45.21-.81.38-.77s.57.31.75.66a8.16,8.16,0,0,1,.55,1.11,7.86,7.86,0,0,1,.47,2.07C580.82,449.1,580.62,449.87,580.74,449.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.61 250.81 643.09 250.33 673.77 451.83 647.42 455.17 613.66 289.49 603.55 455.76 603.52 456.26 575.03 455.76 579.61 250.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.53,285.15a13,13,0,0,0-.16-2.45c-.15-1.52-.31-3.6-.38-5.91s0-4.41,0-5.92a13,13,0,0,0,0-2.47,10.26,10.26,0,0,0-.38,2.44,49.38,49.38,0,0,0,.36,11.9A9.28,9.28,0,0,0,611.53,285.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.3,269s-.11-.12-.37-.14a1.61,1.61,0,0,0-1,.31,1.84,1.84,0,0,0-.8,1.45,1.85,1.85,0,0,0,3.21,1.09,1.86,1.86,0,0,0,.26-1.64,1.63,1.63,0,0,0-.65-.88c-.22-.14-.37-.14-.38-.12s.51.3.67,1.1a1.51,1.51,0,0,1-.28,1.24,1.39,1.39,0,0,1-2.34-.8,1.55,1.55,0,0,1,.53-1.15C605.71,268.91,606.3,269.07,606.3,269Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.56,264.92s.18.22.58.53a10.54,10.54,0,0,0,1.81,1.14,14.68,14.68,0,0,0,3,1.12,16.49,16.49,0,0,0,3.86.49,17.14,17.14,0,0,0,3.87-.48,14.66,14.66,0,0,0,3-1.13,10.6,10.6,0,0,0,1.81-1.13c.39-.31.6-.5.58-.53s-.94.6-2.55,1.33a16.66,16.66,0,0,1-2.93,1,16.42,16.42,0,0,1-7.51,0,15.16,15.16,0,0,1-2.93-1C623.5,265.52,622.62,264.84,622.56,264.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.26,269.19a4.39,4.39,0,0,0,1.74.37,12.25,12.25,0,0,0,8.14-2.33,4.4,4.4,0,0,0,1.28-1.23,16.48,16.48,0,0,1-11.16,3.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.72,453.66a2.79,2.79,0,0,1-.18-.43c-.09-.29-.22-.74-.36-1.33-.28-1.18-.66-2.93-1.12-5.2-.9-4.53-2.14-11.09-3.62-19.22-3-16.25-6.9-38.72-11.25-63.55s-8.32-47.28-11.18-63.57c-1.47-8.11-2.66-14.68-3.48-19.25-.43-2.25-.76-4-1-5.23-.12-.58-.21-1-.27-1.36l-.11-.46s0,.16.05.47.13.79.22,1.37c.21,1.22.5,3,.89,5.24.78,4.58,1.91,11.16,3.31,19.28l11,63.6c4.34,24.83,8.35,47.29,11.4,63.53,1.52,8.12,2.81,14.68,3.78,19.19S663.53,453.74,663.72,453.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.81,451.39s0-.16,0-.47,0-.78,0-1.36c0-1.22,0-3,0-5.24s0-5.07.09-8.3.07-6.92.18-11c.16-8.14.47-17.83.94-28.58s1.18-22.57,2.09-34.95,2-24.18,3.15-34.89,2.28-20.33,3.34-28.41c.5-4,1-7.68,1.45-10.89s.83-6,1.16-8.21.56-4,.73-5.19c.08-.58.14-1,.18-1.36a3.89,3.89,0,0,0,0-.46s0,.15-.09.46-.14.77-.23,1.34c-.2,1.21-.48,2.95-.83,5.18s-.79,5-1.25,8.2-1,6.85-1.53,10.89c-1.1,8.07-2.28,17.69-3.45,28.4s-2.25,22.5-3.19,34.9-1.58,24.21-2.05,35-.72,20.45-.83,28.6c-.08,4.07-.08,7.75-.11,11s0,6,0,8.3,0,4,0,5.24c0,.58,0,1,0,1.36S582.81,451.39,582.81,451.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.17,173.14l39.67,11.58,22.22-13.12,16.86,20-31.45,13.62a16.39,16.39,0,0,1-14-.46l-39-20Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.12,169.32l-4.91-2.55-13.66-7.11a1.27,1.27,0,0,0-1.58,1.8l8.71,7.16L493,170a3.13,3.13,0,0,0-1.67,1.51l-1.93,3.85s-2.22.24-2.44,1.67,1.44,1.94,1.44,1.94l-.42,1.68a2.84,2.84,0,0,0,.41,2.28h0c2.11.87,3.79-3.56,3.79-3.56l2.26.24,2.46,5c3.13.76,1.65-4.18,1.65-4.18l1.38.35c1.38.34,2.1,1.32,4.25,2.42s6.36,1.49,6.36,1.49l3.12,2.3L523.16,174Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.12,169.32l.27.05.77.22,3,.89,11.08,3.38.23.07-.15.19-9.41,13-.14.19-.18-.14-3.13-2.29.12,0a22.49,22.49,0,0,1-6.16-1.36,19.17,19.17,0,0,1-2.84-1.72,5.81,5.81,0,0,0-1.41-.75c-.51-.14-1.08-.27-1.62-.41l.3-.32a8.3,8.3,0,0,1,.34,2.84,2.06,2.06,0,0,1-.68,1.44,2,2,0,0,1-1.61.22l-.11,0-.06-.12c-.78-1.58-1.62-3.26-2.47-5l.21.15-2-.21-.28,0,.27-.16a11.08,11.08,0,0,1-1.21,2.25,3.31,3.31,0,0,1-2.09,1.57h-.36c-.12,0-.23-.06-.35-.09l-.08,0h-.05s-.22-.18-.12-.09h0l-.09-.14-.15-.3a3.21,3.21,0,0,1-.27-1.29,5.34,5.34,0,0,1,.22-1.25l.29-1.17.19.32a2.43,2.43,0,0,1-1.35-.91,1.85,1.85,0,0,1-.2-1.63,2.19,2.19,0,0,1,1.12-1.14,4.72,4.72,0,0,1,1.46-.43l-.2.14,1.22-2.43.61-1.19a3.58,3.58,0,0,1,.79-1.15,3.28,3.28,0,0,1,1.19-.73l1.21-.46,2.37-.9-.07.41-8.69-7.19,0,0,0,0a1.48,1.48,0,0,1,.21-1.72,1.46,1.46,0,0,1,1.62-.36h0l13.54,7.15,3.67,2,.95.53a1.56,1.56,0,0,1,.32.2,2.94,2.94,0,0,1-.34-.15l-1-.47-3.74-1.88-13.61-7h0a1.07,1.07,0,0,0-1.18.27,1.09,1.09,0,0,0-.14,1.25l0-.06,8.73,7.14.31.26-.38.14-2.36.91-1.21.46a3,3,0,0,0-1,.63,3.22,3.22,0,0,0-.69,1l-.6,1.19-1.22,2.43-.06.12-.14,0c-.84.12-1.86.48-2.15,1.24a1.38,1.38,0,0,0,.14,1.17,2,2,0,0,0,1.05.7l.25.07-.06.24-.29,1.17a4.27,4.27,0,0,0-.2,1.12,2.68,2.68,0,0,0,.22,1.08l.13.24.07.12v0h0c.11.08-.14-.12-.11-.1h0l.06,0a1.83,1.83,0,0,0,.25.06h.25a2.87,2.87,0,0,0,1.72-1.35,10.45,10.45,0,0,0,1.14-2.14l.08-.19.19,0,.28,0,2,.21.15,0,.06.12c.84,1.71,1.68,3.39,2.46,5l-.17-.13a1.51,1.51,0,0,0,1.18-.13,1.59,1.59,0,0,0,.48-1.09,7.52,7.52,0,0,0-.32-2.63l-.11-.43.42.11c.56.14,1.08.26,1.66.42a6.06,6.06,0,0,1,1.53.82,19.13,19.13,0,0,0,2.77,1.68,22.11,22.11,0,0,0,6,1.34h.06l.05,0,3.12,2.31-.32.05c3.61-4.91,6.84-9.29,9.5-12.92l.09.27-11-3.54-2.94-1-.76-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.91,180.5c0,.05-1.09-.14-2.94-.41s-4.47-.61-7.55-.87h.05a1.72,1.72,0,0,1-1.59-2.39,3.31,3.31,0,0,1,2.63-1.85c1.18-.19,2.26-.25,3.32-.44s2.08-.38,3-.63,1.86-.51,2.69-.79a2.82,2.82,0,0,0,1.05-.54.72.72,0,0,0,.21-.85,2.67,2.67,0,0,0-.63-.77l-.67-.68c-.42-.43-.78-.78-1.09-1.06-.62-.55-1-.78-1-.82a3.58,3.58,0,0,1,1.14.67,14.17,14.17,0,0,1,1.16,1l.7.65a2.76,2.76,0,0,1,.74.86,1.11,1.11,0,0,1-.28,1.29,3.07,3.07,0,0,1-1.18.66c-.84.3-1.74.59-2.71.85s-2,.48-3.06.66-2.22.27-3.31.45a2.79,2.79,0,0,0-2.25,1.52,1.23,1.23,0,0,0,1.05,1.73h0c3.1.3,5.72.7,7.56,1.06.92.18,1.65.34,2.14.47A2.62,2.62,0,0,1,498.91,180.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.55,173.49a4.77,4.77,0,0,1-2.62.35,7.59,7.59,0,0,1-1.38-.18l.24-.14c-.3.68-.54,1.11-.63,1.08s0-.52.21-1.23l.05-.16.19,0,1.35.09A12.63,12.63,0,0,1,498.55,173.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.11 157.07 562.55 176.68 580.47 200.28 602.33 187.87 588.11 157.07",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.11,157.07h0c3.7-2.27,16.49-5.08,16.49-5.08l24.74-2.69,21.46,9.85L642,196.08l7.72,69.63-73.65,4Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.47,
    y: 187.96,
    width: 12.69,
    height: 3.42,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.18,191.41H617.44v-3.47h12.74Zm-12.69,0h12.64V188H617.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,178.44a30.31,30.31,0,0,1-.37-5.67,32.28,32.28,0,0,1,.16-5.68,30.52,30.52,0,0,1,.37,5.67A32.13,32.13,0,0,1,585,178.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.43,115.41l-2.71,38.35a12,12,0,0,1-11.92,11.11h0a12,12,0,0,1-11.93-12.74c.24-3.65.45-6.63.45-6.63s-9.28-1.45-9.39-10.73c-.07-5.36.86-17.53,1.65-26.84a12.16,12.16,0,0,1,12.13-11.14h5.61A17.18,17.18,0,0,1,631.43,115.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.31,145.36a21.56,21.56,0,0,0,12.1-3.44s-2.86,6.68-12.12,5.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.47,119.65a1.32,1.32,0,0,0,1.27,1.34,1.26,1.26,0,0,0,1.37-1.19,1.33,1.33,0,0,0-1.28-1.34A1.26,1.26,0,0,0,599.47,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.18,117.23c.16.18,1.17-.57,2.59-.56s2.47.71,2.63.54-.09-.39-.55-.72a3.66,3.66,0,0,0-2.1-.65,3.44,3.44,0,0,0-2.07.67C599.25,116.84,599.1,117.16,599.18,117.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.18,119.66a1.32,1.32,0,0,0,1.28,1.33,1.26,1.26,0,0,0,1.36-1.19,1.33,1.33,0,0,0-1.27-1.34A1.27,1.27,0,0,0,613.18,119.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.2,117.5c.16.17,1.17-.57,2.59-.57s2.47.72,2.63.55-.09-.39-.55-.73a3.59,3.59,0,0,0-2.1-.64,3.51,3.51,0,0,0-2.07.66C613.27,117.11,613.12,117.42,613.2,117.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.15,127.72a9.5,9.5,0,0,0-2.31-.41c-.37,0-.71-.11-.77-.36a1.78,1.78,0,0,1,.24-1.08c.34-.88.7-1.81,1.08-2.77,1.49-3.95,2.58-7.2,2.42-7.26s-1.51,3.09-3,7c-.36,1-.71,1.91-1,2.79a2.08,2.08,0,0,0-.19,1.43.94.94,0,0,0,.6.54,2.45,2.45,0,0,0,.62.08A8.5,8.5,0,0,0,608.15,127.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.83,112.55c.14.39,1.56.21,3.24.41s3,.66,3.25.31c.1-.17-.14-.53-.69-.91a5.66,5.66,0,0,0-4.94-.54C613.08,112.06,612.77,112.37,612.83,112.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.19,114.43c.25.33,1.24,0,2.42,0s2.18.21,2.41-.13c.1-.16-.06-.48-.49-.79a3.5,3.5,0,0,0-3.89.12C599.22,113.94,599.08,114.28,599.19,114.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.3,122.38c.16-.07,6.38-1.89,6.18,4.46s-6.54,4.83-6.54,4.65S628.3,122.38,628.3,122.38Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,129.15s.11.08.3.17a1.06,1.06,0,0,0,.82,0,2.73,2.73,0,0,0,1.35-2.41,3.7,3.7,0,0,0-.26-1.59,1.29,1.29,0,0,0-.81-.88.56.56,0,0,0-.66.28c-.09.18-.05.31-.09.32s-.13-.11-.07-.38a.69.69,0,0,1,.26-.38.85.85,0,0,1,.62-.15,1.56,1.56,0,0,1,1.12,1,3.72,3.72,0,0,1,.33,1.79,2.87,2.87,0,0,1-1.7,2.68,1.16,1.16,0,0,1-1-.2C630,129.3,629.93,129.16,630,129.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.83,122.16a3.33,3.33,0,0,0-3.05,1.57c-.42.91-.51,1.93-.92,2.84a2.24,2.24,0,0,1-2.31,1.5,2,2,0,0,1-1.32-1.45,5.24,5.24,0,0,1,0-2.05c.37-3,1-5.9,1.12-8.88a15.21,15.21,0,0,0-1.88-8.63,8.32,8.32,0,0,0-7.42-4.18c-2,.16-3.78,1.19-5.74,1.47a7.79,7.79,0,0,1-6.44-2.15,13.06,13.06,0,0,0-1.2-.87,3.65,3.65,0,0,1,.66-2c3.89-3.6,10.89-4.6,16-3.31a18.52,18.52,0,0,1,12.15,9.73c2.21,4.81,1.56,11.51.34,16.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.47,106.49s24.35-7.83,34.89,13.24c0,0,1.57-5.28,1.57-8.1,0-1.89-1.13-13.13-12.69-16.67C621.24,95,603.81,88.31,597.47,106.49Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.4,107a5.3,5.3,0,0,1-8.43.77,3.13,3.13,0,0,1-5.91-.31,7.07,7.07,0,0,1-2.37,1.73,2.42,2.42,0,0,1-2.7-.57,2.35,2.35,0,0,1,.17-2.79,5.67,5.67,0,0,1,2.46-1.66,17.86,17.86,0,0,1,9.19-1.4,12.38,12.38,0,0,1,8.06,4.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.47,106.49a11.36,11.36,0,0,1,7.75-3.51c7.18-.32,20.62,3.72,27.14,16.75,0,0,1.57-5.28,1.57-8.1,0-1.89-1.13-13.13-12.69-16.67C621.24,95,603.81,88.31,597.47,106.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M631.34,117.26a45.92,45.92,0,0,0-14.19-13.59c-5.59-3.5-14.85-7-21.23-8.65a13.94,13.94,0,0,0-5.86-.61A5.31,5.31,0,0,0,585.71,98c-.6,2.4,3.66,6.11,5.67,7.57a65.06,65.06,0,0,0,6.09,3.6s-.05-4.46,7.09-5.38C614.27,102.51,631.34,117.26,631.34,117.26Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.37,99.06a23,23,0,0,0-7-2.39,9.32,9.32,0,0,1,1.91-1.15,18.12,18.12,0,0,1,5.48,1.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,122.6a11.26,11.26,0,0,1-1.32,1c-1,.74-2.06,1.5-3.19,2.34a33.17,33.17,0,0,1-4.67,3.13,28.37,28.37,0,0,1,4.36-3.55C627.62,123.66,629.84,122.39,630,122.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.6,131.86a19.35,19.35,0,0,1-8.52,7.22c-.07-.14,2.11-1.38,4.46-3.38S630.48,131.76,630.6,131.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.7,128.79a20.46,20.46,0,0,0,3.17.68c4.6-.25,6.21-1.8,13.72-.2a10.4,10.4,0,0,0,3.69.11,31.29,31.29,0,0,1,4.49-.32l1.45,10s-8.91,7.79-16.93,6.92C594.91,144.88,593.69,132.78,595.7,128.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.7,128.79s-.09.26-.27.73a10.61,10.61,0,0,0-.43,2.18,15.83,15.83,0,0,0,1.45,8A11.34,11.34,0,0,0,600,144a11.5,11.5,0,0,0,6.06,2,16.8,16.8,0,0,0,7-1.39,33.62,33.62,0,0,0,6.73-3.73c.82-.59,1.62-1.18,2.36-1.82l0,.1c-.51-3.52-1-6.89-1.44-10l.09.08a40.85,40.85,0,0,0-5.3.4,10.44,10.44,0,0,1-2.51-.13c-.8-.15-1.56-.33-2.32-.44a24.23,24.23,0,0,0-4.28-.36,23.42,23.42,0,0,0-3.66.4c-1.1.19-2.09.35-3,.42a6.33,6.33,0,0,1-1.22,0c-.37,0-.7-.13-1-.2-1.19-.28-1.81-.49-1.81-.49a12.13,12.13,0,0,0,7,.12,20.85,20.85,0,0,1,8-.08c.76.1,1.54.28,2.33.43a10.55,10.55,0,0,0,2.46.12,39.18,39.18,0,0,1,5.32-.41h.09v.08c.46,3.14.94,6.51,1.45,10v0l0,0c-.76.64-1.56,1.24-2.38,1.83a34.31,34.31,0,0,1-6.78,3.75,16.94,16.94,0,0,1-7.06,1.39,11,11,0,0,1-9.76-6.4,15.74,15.74,0,0,1-1.39-8.05,10.28,10.28,0,0,1,.47-2.19C595.59,129,595.7,128.79,595.7,128.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.54,134.64a24.53,24.53,0,0,0,22.27-.41,16.25,16.25,0,0,1-4.74,4.28c-2.19,1.12-4.75,1.18-7.22,1.17a12.86,12.86,0,0,1-5.75-.92,13.23,13.23,0,0,1-4.31-4.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.75,132.11a13.09,13.09,0,0,1-2.88.75,45.54,45.54,0,0,1-7.13.82,47,47,0,0,1-7.17-.31,13.54,13.54,0,0,1-2.92-.55,23.19,23.19,0,0,1,3,.18,61.74,61.74,0,0,0,14.2-.5A22.77,22.77,0,0,1,617.75,132.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.47,136.28a7.9,7.9,0,0,1-2,2,16.86,16.86,0,0,1-12.78,3.54,8.33,8.33,0,0,1-2.71-.7c0-.08,1.06.19,2.76.33a18.39,18.39,0,0,0,12.5-3.46C618.67,137,619.41,136.22,619.47,136.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.63,134a3.13,3.13,0,0,1-.8.52,17.64,17.64,0,0,1-2.35,1.09,23.66,23.66,0,0,1-3.7,1.09,25.86,25.86,0,0,1-4.68.52,26.71,26.71,0,0,1-4.71-.37,22.57,22.57,0,0,1-3.72-1,16.92,16.92,0,0,1-2.39-1,3,3,0,0,1-.81-.49c0-.08,1.25.52,3.31,1.15a27.42,27.42,0,0,0,3.69.86,27.1,27.1,0,0,0,9.22-.15,27.26,27.26,0,0,0,3.66-1C618.39,134.53,619.58,133.89,619.63,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.17,134a25.91,25.91,0,0,1-11.83-.49c0-.15,2.65.29,5.91.41S612.16,133.83,612.17,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.75 258.66 501.75 177.57 614.54 177.57 614.54 258.66 554.76 259.16 501.75 258.66",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 501.75,
    y: 177.57,
    width: 112.8,
    height: 81.09
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "554.76 259.16 501.75 258.66 501.75 177.57 554.59 177.57 554.76 259.16",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.3,
    y: 177.57,
    width: 7.03,
    height: 14.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.51,
    y: 240.76,
    width: 14,
    height: 14,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.54,254.79H505.48v-14h14.06Zm-14,0h13.95v-14H505.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.94,196.19l2.33,18.87-35,20.77,5.44,12,39.78-16.07c4.82-2.45,8.94-6.07,8.6-11.49l-1.91-26.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.8,159.15a19,19,0,0,1,6.38,11.37c1.34,7.31,5.89,27.75,5.89,27.75l-24,2.84,0-5.62c0-.08-2.24-10.54-2.24-10.54l4.47-14.43Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.12,198.36a10.41,10.41,0,0,1-1.64.29l-4.49.62c-3.79.5-9,1.16-14.84,1.85l-2,.24-.27,0,0-.28c-.4-5.35-.84-10.1-1.16-13.52-.16-1.64-.29-3-.39-4a9,9,0,0,1-.09-1.48,8,8,0,0,1,.28,1.46c.15.94.33,2.31.55,4,.41,3.41.92,8.17,1.33,13.53l-.29-.24,2-.24c5.8-.7,11-1.3,14.86-1.7l4.51-.46A9.82,9.82,0,0,1,662.12,198.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.83,160.47c0,.08-.87.45-2.2,1.27a19.16,19.16,0,0,0-7.72,9.14c-.59,1.45-.8,2.41-.89,2.39a7.92,7.92,0,0,1,.54-2.52,17.1,17.1,0,0,1,7.89-9.33A7.7,7.7,0,0,1,648.83,160.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.73,234.78l-5.14,2.35-2.2-.85-11.22-.7-7,1.55-.2.4c0,3.81,7.21,2.31,9.42,2.91s.2,5.31.2,5.31-9.92,12.93-11.65,16c-.86,1.55-.58,2.4-.08,2.87a1.49,1.49,0,0,0,1.87.06l3.66-2.59s10.08.59,10.77.25a10.6,10.6,0,0,0,2.45-2.6A76.63,76.63,0,0,1,614.54,248Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.73,234.78s0,.06.13.2.21.39.36.66l1.37,2.58c1.21,2.31,2.95,5.61,5.11,9.71l.07.15-.15.08A77,77,0,0,0,598.75,260l0,0a10.69,10.69,0,0,1-2.35,2.57,1.18,1.18,0,0,1-.5.18l-.45,0-.9,0-1.79,0c-2.41-.06-4.89-.17-7.43-.31l.16-.05L583.14,264l-1.2.86a1.86,1.86,0,0,1-1.62.33,1.65,1.65,0,0,1-1.16-1.22,2.72,2.72,0,0,1,.2-1.63A16.41,16.41,0,0,1,581,259.7c3.48-5,7.07-9.7,10.42-14.1l0,.05a12.65,12.65,0,0,0,.65-2.09,4.62,4.62,0,0,0,.08-2.05,1.16,1.16,0,0,0-.5-.72,2.4,2.4,0,0,0-.93-.22c-.69-.07-1.4-.06-2.09-.07a20.79,20.79,0,0,1-4.11-.28,4.42,4.42,0,0,1-1.88-.83,2.52,2.52,0,0,1-.83-1.86v0l0-.05.2-.4,0-.09.1,0,7-1.52h.06l11.21.76h0l2.2.87h-.08l3.87-1.7,1-.43.32-.12-.34.18-1,.48-3.77,1.79,0,0-.05,0-2.21-.83h0l-11.22-.64h.05l-7,1.58.14-.11-.2.4,0-.1a2.08,2.08,0,0,0,.69,1.52,3.8,3.8,0,0,0,1.69.72,20.14,20.14,0,0,0,4,.26c.7,0,1.4,0,2.13.06a2.93,2.93,0,0,1,1.14.28,1.68,1.68,0,0,1,.72,1,5.09,5.09,0,0,1-.06,2.3,13.39,13.39,0,0,1-.68,2.18v0l0,0c-3.34,4.41-6.92,9.09-10.39,14.09a17,17,0,0,0-1.54,2.56,2.29,2.29,0,0,0-.18,1.32,1.17,1.17,0,0,0,.8.85,1.35,1.35,0,0,0,1.18-.26l1.21-.86,2.38-1.68.07-.05h.09c2.53.14,5,.26,7.41.33l1.78,0,.87,0,.42,0a.73.73,0,0,0,.31-.11,10.47,10.47,0,0,0,2.21-2.43l0,0v0a76.37,76.37,0,0,1,16-11.75l-.07.23-4.89-9.71c-.56-1.13-1-2-1.32-2.65l-.34-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.87,253.41a52.85,52.85,0,0,1-4.63,4.48c-1.31,1.21-2.51,2.29-3.38,3.06a8,8,0,0,1-1.49,1.18,34,34,0,0,1,4.51-4.62A31.88,31.88,0,0,1,594.87,253.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.92,255.91a14.68,14.68,0,0,1-2.91,3.52,17.26,17.26,0,0,1-3.45,3,23.71,23.71,0,0,1,3.08-3.36A31.05,31.05,0,0,1,597.92,255.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Doorbell--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 139.31,
    width: 32.14,
    height: 45.05,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 139.31,
    width: 32.14,
    height: 5.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 179.14,
    width: 32.14,
    height: 5.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.96,
    y: 147.74,
    width: 19.53,
    height: 10.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.35,152.83c-.05,0-.05-.41-.24-1.09a4.62,4.62,0,0,0-1.69-2.41,4.38,4.38,0,0,0-7,3.5,4.37,4.37,0,0,0,2.84,4.08,4.41,4.41,0,0,0,4.15-.58,4.67,4.67,0,0,0,1.68-2.4c.19-.69.19-1.1.24-1.1s0,.1,0,.3a3.37,3.37,0,0,1-.09.85,4.56,4.56,0,0,1-1.65,2.64,4.72,4.72,0,0,1-4.53.74,4.81,4.81,0,0,1,0-9.06,4.77,4.77,0,0,1,4.53.74,4.55,4.55,0,0,1,1.65,2.65,3.29,3.29,0,0,1,.09.85C463.38,152.73,463.37,152.83,463.35,152.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.21,161.84a.76.76,0,1,1-.76-.76A.76.76,0,0,1,451.21,161.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,161.84a.76.76,0,1,1-.76-.76A.76.76,0,0,1,456.94,161.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.67,161.84a.75.75,0,0,1-.75.75.76.76,0,1,1,.75-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.45,
    cy: 166.69,
    r: 0.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,166.69a.76.76,0,1,1-.76-.76A.76.76,0,0,1,456.94,166.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.92,
    cy: 166.69,
    r: 0.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.45,
    cy: 171.55,
    r: 0.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,171.55a.76.76,0,1,1-.76-.76A.76.76,0,0,1,456.94,171.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.92,
    cy: 171.55,
    r: 0.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.88,
    cy: 166.69,
    r: 2.75,
    style: {
      fill: "#1990FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.37,
    y: 38.02,
    width: 18.6,
    height: 432.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.16,
    y: 56.28,
    width: 185.21,
    height: 414.49,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.21,
    y: 38.02,
    width: 17.14,
    height: 432.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.21,
    y: 38.02,
    width: 215.76,
    height: 18.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,38s-.22.29-.69.73l-2,1.84-6.67,6c-2.58,2.37-4.89,4.55-6.47,6.21a20.91,20.91,0,0,0-1.77,2,5.6,5.6,0,0,0-.38.61c-.05.15-.08.24-.1.24s0-.09,0-.27a2.91,2.91,0,0,1,.31-.69,14.81,14.81,0,0,1,1.67-2.18,89.24,89.24,0,0,1,6.39-6.35c2.6-2.37,5-4.45,6.78-5.92.88-.74,1.61-1.32,2.12-1.72A4.52,4.52,0,0,1,429,38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.35,56.66c-.1.09-4-4-8.76-9.14s-8.48-9.4-8.38-9.5,4,4,8.76,9.14S230.46,56.56,230.35,56.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.21,
    y: 244.88,
    width: 12.46,
    height: 55.36,
    rx: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,286.64a2.11,2.11,0,1,0-3,1.87V291a.94.94,0,0,0,.94.94h0a.94.94,0,0,0,.95-.94v-2.44A2.11,2.11,0,0,0,244,286.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.28,
    y: 263.52,
    width: 34.31,
    height: 6.62,
    rx: 3.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,270.33a4.38,4.38,0,0,1-1.05.09l-2.84.12a25.26,25.26,0,0,1-4.24-.14,9.73,9.73,0,0,1-2.47-.62A4.43,4.43,0,0,1,241,268a3.17,3.17,0,0,1-.13-2.81,2.29,2.29,0,0,1,.94-1,5.83,5.83,0,0,1,1.17-.49,13.13,13.13,0,0,1,4.24-.5c1.2,0,2.17.06,2.84.1a4.66,4.66,0,0,1,1,.11,32.39,32.39,0,0,1-3.88.15,14.06,14.06,0,0,0-4.09.59,2.7,2.7,0,0,0-1.8,1.29,2.65,2.65,0,0,0,.13,2.34,3.89,3.89,0,0,0,1.87,1.6,8.91,8.91,0,0,0,2.33.61,29.33,29.33,0,0,0,4.17.26A21.85,21.85,0,0,1,253.75,270.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.66,149.09s0-.12,0-.34,0-.54,0-.95c0-.85,0-2.08,0-3.68,0-3.22,0-7.91-.06-13.86,0-11.89-.07-28.78-.12-48.87l.23.23-55,0h0l.26-.26c0,25,0,48.33,0,67.7l-.22-.22,39.84.11,11.15.06,2.95,0,1,0-1,0-2.91,0-11.1.06-40,.11h-.22v-.21c0-19.37,0-42.66,0-67.7v-.26h.27l55,0h.24v.23c0,20.15-.09,37.1-.12,49,0,5.92,0,10.6-.06,13.81q0,2.37,0,3.63c0,.4,0,.71,0,.93A1.77,1.77,0,0,1,312.66,149.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.62,140.71a1.46,1.46,0,0,1,0-.26c0-.19,0-.43,0-.73,0-.67,0-1.61,0-2.83,0-2.48,0-6.07-.06-10.61,0-9.09-.07-22-.12-37.18l.24.23-37.87,0c-.06,0,.49-.49.26-.25h0v3.57c0,1.19,0,2.38,0,3.56v7c0,4.61,0,9.1,0,13.44,0,8.68,0,16.77,0,24l-.21-.22,27.47.12,7.66,0,2,0,.71,0-.67,0-2,0-7.61.06-27.61.11h-.22v-.21c0-7.25,0-15.34,0-24,0-4.34,0-8.83,0-13.44V89.12h0l.27-.27,37.87,0h.23v.24c-.05,15.29-.09,28.21-.12,37.34,0,4.51,0,8.08-.06,10.55,0,1.2,0,2.12,0,2.78v.71C303.62,140.63,303.62,140.71,303.62,140.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.66,292s0-.22,0-.63,0-1,0-1.82c0-1.61,0-4,0-7,0-6.14,0-15.07-.07-26.29,0-22.44-.07-54-.11-90.79l.24.25h-55l.26-.26c0,49.29,0,94-.07,126.57l-.19-.18,40.16.1,11,0,2.86,0,1,0s-.31,0-1,0l-2.82,0-10.91.05-40.28.1h-.18V292c0-32.58,0-77.28-.08-126.57v-.26h55.47v.25c-.05,36.81-.09,68.47-.12,91,0,11.21-.05,20.12-.06,26.24,0,3,0,5.39,0,7,0,.78,0,1.38,0,1.79S312.66,292,312.66,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.62,285s0-.2,0-.56,0-.93,0-1.63c0-1.45,0-3.55,0-6.27,0-5.47,0-13.41-.07-23.35,0-19.88-.07-47.79-.12-79.95l.26.25H265.75l.26-.26c0,44.68-.07,84.78-.09,111.76l-.17-.17,27.78.09,7.47,0,1.94,0,.68,0-.64,0h-1.91l-7.44.05-27.88.09h-.18V285c0-27-.05-67.08-.09-111.76V173h38.39v.25c-.05,32.23-.09,60.2-.12,80.12,0,9.92-.05,17.84-.07,23.29,0,2.7,0,4.79,0,6.22,0,.69,0,1.22,0,1.6S303.62,285,303.62,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.66,452.28s0-.22,0-.63,0-1,0-1.82c0-1.61,0-4,0-7,0-6.14,0-15.07-.07-26.29,0-22.44-.07-54.05-.11-90.79l.24.25h-55l.26-.26c0,49.29,0,94-.07,126.57l-.19-.19,40.16.11,11,0,2.86,0,1,0-1,0-2.82,0-10.91.05-40.28.1h-.18v-.19c0-32.58,0-77.28-.08-126.57v-.26h55.47v.25c-.05,36.81-.09,68.47-.12,91,0,11.21-.05,20.12-.06,26.24,0,3,0,5.39,0,7,0,.78,0,1.38,0,1.79S312.66,452.28,312.66,452.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.62,445.27s0-.2,0-.57,0-.92,0-1.62c0-1.45,0-3.55,0-6.27,0-5.47,0-13.41-.07-23.35,0-19.88-.07-47.79-.12-79.95l.26.25H265.75l.26-.26c0,44.68-.07,84.78-.09,111.76l-.17-.17,27.78.09,7.47,0,1.94,0,.68,0-.64,0h-1.91l-7.44.05-27.88.09h-.18v-.17c0-27-.05-67.08-.09-111.76v-.26h38.39v.25c-.05,32.23-.09,60.2-.12,80.12,0,9.92-.05,17.84-.07,23.29,0,2.7,0,4.79,0,6.22,0,.69,0,1.22,0,1.6S303.62,445.27,303.62,445.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,140.68a36.91,36.91,0,0,1-4.7,4.17,38.69,38.69,0,0,1-5,3.75,39.22,39.22,0,0,1,4.7-4.16A39.39,39.39,0,0,1,266.63,140.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,148.09a22.14,22.14,0,0,1-4.82-3.27,23.22,23.22,0,0,1-4.18-4.06c.11-.11,2,1.64,4.51,3.65S313.06,148,313,148.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.85,83a27.25,27.25,0,0,1-4.15,3.34,26.88,26.88,0,0,1-4.46,2.92,27.34,27.34,0,0,1,4.15-3.34A27.68,27.68,0,0,1,311.85,83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,88.24a19.09,19.09,0,0,1-4.55-2.56,18.68,18.68,0,0,1-4-3.34,45.85,45.85,0,0,1,4.31,2.91A43.67,43.67,0,0,1,265.9,88.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.55,173.37a18.47,18.47,0,0,1-7.79-8.8c.14-.07,1.4,2.27,3.57,4.69S265.64,173.24,265.55,173.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,165.35a28.27,28.27,0,0,1-3.9,3.77,28.29,28.29,0,0,1-4.24,3.38,28.92,28.92,0,0,1,3.9-3.77A27.93,27.93,0,0,1,312,165.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.53,285.54c.08.13-1.74,1.45-3.81,3.29s-3.62,3.49-3.73,3.39a15.07,15.07,0,0,1,3.38-3.78A15.92,15.92,0,0,1,265.53,285.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,291.86a45.74,45.74,0,0,1-7.28-6.72,24.4,24.4,0,0,1,3.82,3.17A24.1,24.1,0,0,1,311.12,291.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,335a39.61,39.61,0,0,1-4.62-4.43,40.79,40.79,0,0,1-4.24-4.79,39.61,39.61,0,0,1,4.62,4.43A37.83,37.83,0,0,1,266.46,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,325.39a37.4,37.4,0,0,1-4.21,4.41,35.39,35.39,0,0,1-4.57,4,72,72,0,0,1,8.78-8.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63,444.62a49.86,49.86,0,0,1-6.85,7.57,49.86,49.86,0,0,1,6.85-7.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,452.28a20.76,20.76,0,0,1-4.27-3.36,21.18,21.18,0,0,1-3.63-4,45.71,45.71,0,0,1,4,3.66A44.69,44.69,0,0,1,311.75,452.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,149.09s0-.12,0-.34,0-.54,0-.95c0-.85,0-2.08,0-3.68,0-3.22,0-7.91-.06-13.86,0-11.89-.07-28.78-.12-48.87l.23.23-54.95,0h0l.26-.26c0,25,0,48.33,0,67.7l-.22-.22,39.85.11,11.14.06,3,0,1,0-1,0-2.91,0-11.1.06-40,.11h-.22v-.21c0-19.37,0-42.66,0-67.7v-.26h.27l54.95,0h.24v.23c-.05,20.15-.09,37.1-.12,49,0,5.92-.05,10.6-.06,13.81q0,2.37,0,3.63c0,.4,0,.71,0,.93A1.77,1.77,0,0,1,385.81,149.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,140.71a1.46,1.46,0,0,1,0-.26c0-.19,0-.43,0-.73,0-.67,0-1.61,0-2.83,0-2.48,0-6.07-.06-10.61,0-9.09-.07-22-.12-37.18l.24.23-37.87,0c-.06,0,.49-.49.26-.25h0v3.57c0,1.19,0,2.38,0,3.56v7c0,4.61,0,9.1,0,13.44,0,8.68,0,16.77,0,24l-.21-.22,27.47.12,7.66,0,2,0,.71,0-.67,0-2,0-7.61.06-27.61.11h-.22v-.21c0-7.25,0-15.34,0-24,0-4.34,0-8.83,0-13.44v-7c0-1.18,0-2.37,0-3.56V89.12h0l.27-.27,37.87,0H377v.24c-.05,15.29-.09,28.21-.12,37.34,0,4.51,0,8.08-.06,10.55,0,1.2,0,2.12,0,2.78v.71C376.77,140.63,376.77,140.71,376.77,140.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,292s0-.22,0-.63,0-1,0-1.82c0-1.61,0-4,0-7,0-6.14,0-15.07-.07-26.29,0-22.44-.07-54-.11-90.79l.24.25h-55l.26-.26c0,49.29-.05,94-.07,126.57l-.19-.18,40.16.1,11,0,2.86,0,1,0s-.31,0-.95,0L382,292l-10.91.05-40.28.1h-.18V292c0-32.58-.05-77.28-.08-126.57v-.26h55.47v.25c-.05,36.81-.09,68.47-.12,91,0,11.21-.05,20.12-.06,26.24,0,3,0,5.39,0,7,0,.78,0,1.38,0,1.79S385.81,292,385.81,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,285s0-.2,0-.56,0-.93,0-1.63c0-1.45,0-3.55,0-6.27,0-5.47,0-13.41-.07-23.35,0-19.88-.07-47.79-.12-79.95l.26.25H338.9l.26-.26c0,44.68-.07,84.78-.09,111.76l-.17-.17,27.78.09,7.47,0,1.94,0,.68,0-.64,0h-1.91l-7.43.05-27.89.09h-.18V285c0-27-.05-67.08-.09-111.76V173H377v.25c0,32.23-.09,60.2-.12,80.12,0,9.92,0,17.84-.07,23.29,0,2.7,0,4.79,0,6.22,0,.69,0,1.22,0,1.6S376.77,285,376.77,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,452.28s0-.22,0-.63,0-1,0-1.82c0-1.61,0-4,0-7,0-6.14,0-15.07-.07-26.29,0-22.44-.07-54.05-.11-90.79l.24.25h-55l.26-.26c0,49.29-.05,94-.07,126.57l-.19-.19,40.16.11,11,0,2.86,0,1,0-.95,0-2.82,0-10.91.05-40.28.1h-.18v-.19c0-32.58-.05-77.28-.08-126.57v-.26h55.47v.25c-.05,36.81-.09,68.47-.12,91,0,11.21-.05,20.12-.06,26.24,0,3,0,5.39,0,7,0,.78,0,1.38,0,1.79S385.81,452.28,385.81,452.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,445.27s0-.2,0-.57,0-.92,0-1.62c0-1.45,0-3.55,0-6.27,0-5.47,0-13.41-.07-23.35,0-19.88-.07-47.79-.12-79.95l.26.25H338.9l.26-.26c0,44.68-.07,84.78-.09,111.76l-.17-.17,27.78.09,7.47,0,1.94,0,.68,0-.64,0h-1.91l-7.43.05-27.89.09h-.18v-.17c0-27-.05-67.08-.09-111.76v-.26H377v.25c0,32.23-.09,60.2-.12,80.12,0,9.92,0,17.84-.07,23.29,0,2.7,0,4.79,0,6.22,0,.69,0,1.22,0,1.6S376.77,445.27,376.77,445.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.78,140.68a36.91,36.91,0,0,1-4.7,4.17,38.69,38.69,0,0,1-5,3.75,39.22,39.22,0,0,1,4.7-4.16A39.39,39.39,0,0,1,339.78,140.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,148.09a22.14,22.14,0,0,1-4.82-3.27,23.22,23.22,0,0,1-4.18-4.06c.11-.11,2,1.64,4.51,3.65S386.21,148,386.13,148.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,83a27.25,27.25,0,0,1-4.15,3.34,26.88,26.88,0,0,1-4.46,2.92,28,28,0,0,1,4.15-3.34A27.68,27.68,0,0,1,385,83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.05,88.24a19.09,19.09,0,0,1-4.55-2.56,18.68,18.68,0,0,1-4-3.34,45.85,45.85,0,0,1,4.31,2.91A43.67,43.67,0,0,1,339.05,88.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7,173.37a18.47,18.47,0,0,1-7.79-8.8c.14-.07,1.4,2.27,3.57,4.69S338.79,173.24,338.7,173.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.13,165.35a28.27,28.27,0,0,1-3.9,3.77A28.29,28.29,0,0,1,377,172.5a28.92,28.92,0,0,1,3.9-3.77A27.93,27.93,0,0,1,385.13,165.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.68,285.54c.08.13-1.74,1.45-3.81,3.29s-3.62,3.49-3.73,3.39a15.07,15.07,0,0,1,3.38-3.78A15.92,15.92,0,0,1,338.68,285.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.27,291.86a45.74,45.74,0,0,1-7.28-6.72,24.4,24.4,0,0,1,3.82,3.17A24.1,24.1,0,0,1,384.27,291.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,335a39.61,39.61,0,0,1-4.62-4.43,40.79,40.79,0,0,1-4.24-4.79,38.72,38.72,0,0,1,4.62,4.43A37.83,37.83,0,0,1,339.61,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.63,325.39a36.42,36.42,0,0,1-4.21,4.41,35.39,35.39,0,0,1-4.57,4,72,72,0,0,1,8.78-8.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,444.62a49.86,49.86,0,0,1-6.85,7.57,24.83,24.83,0,0,1,3.23-4A25.89,25.89,0,0,1,337.78,444.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,452.28a20.76,20.76,0,0,1-4.27-3.36,21.18,21.18,0,0,1-3.63-4,45.71,45.71,0,0,1,4,3.66A44.69,44.69,0,0,1,384.9,452.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.01,
    y: 382.59,
    width: 122.66,
    height: 88.18,
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.91,382.59c.17,0,0,18.62,0,18.62h-9.08V382.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 432.34,
    y: 382.59,
    width: 61.33,
    height: 88.18,
    transform: "translate(926.01 853.36) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 374.75,
    y: 453.51,
    width: 16.42,
    height: 11.62,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.19,465.15H374.72V453.48h16.47Zm-16.42,0h16.37V453.53H374.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.2,
    y: 453.51,
    width: 8.21,
    height: 11.62,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,465.15h-8.26V453.48h8.26Zm-8.2,0h8.15V453.53h-8.15Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.9deeeeb7a4d73f7ee21de5bb7daa890f.svg";
export { ForwardRef as ReactComponent };